import React from "react";
// Customizable Area Start
import {
  Box,
  Button,
  Typography,
  TableContainer,
  TablePagination,
  IconButton,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableBody,
  styled
} from "@material-ui/core";

import {
  createTheme,
  ThemeProvider,
  withStyles,
} from "@material-ui/core/styles";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import LateDeliveryListController, { Props, configJSON } from "./LateDeliveryListController.web";

import SortingTableHeader from "../../../components/src/SortingTableHeader";
import SortingTableCell from "../../../components/src/SortingTableCell";
import CustomSwitch from "../../../components/src/CustomSwitch.web";
import PageHeader from "../../../components/src/PageHeader";
import { TableRowsSkeleton } from "../../../components/src/customComponents/TableRowsSkeleton.web";
import TablePopover from "../../../components/src/TablePopover.web";
// Customizable Area End

const theme = createTheme({
  palette: {
    primary: {
      main: "#0000ff",
      contrastText: "#fff",
    },
  },
});

export default class LateDeliveryList extends LateDeliveryListController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  // Customizable Area End

  render() {
    // Customizable Area Start
    const Strings = configJSON.LateDeliveryListPage.Strings;

    const rows = this.state.lateDeliveryList.map((config: any) => {
      return this.createData(
        config.id,
        config.attributes.name,
        config.attributes.hours,
        config.attributes.color,
        config.attributes.is_active ? "Active" : "Deactivated"
      );
    });

    const filteredRows = rows.slice(
      this.state.page * this.state.pageSize,
      (this.state.page + 1) * this.state.pageSize
    );

    return (
      <ThemeProvider theme={theme}>
        <Box style={webStyle.mainWrapper}>
          <Box className="pageWrapper">
            <PageHeader
              isLoadingPermission={false}
              header={Strings.pageTitle}
              buttonText={Strings.addButton}
              onButtonClick={this.handleAddConfig}
              permissionStatus={true}
              buttonStyle={{ width: 240 }}
            />
            <TableContainer component={Paper} className="flexItem">
              <Table
                style={webStyle.table}
                aria-label="customized table"
              >
                <TableHead className="stickyHeader">
                  <TableRow style={{ background: "#204B9C", color: "#FFFFFF" }}>
                    <SortingTableHeader
                      sortingData={{}}
                      title={Strings.name}
                      sortingKey=""
                      type="left"
                      width="25%"
                      sortingDisabled
                    />
                    <SortingTableHeader
                      sortingData={{}}
                      title={Strings.hours}
                      sortingKey=""
                      width="20%"
                      sortingDisabled
                    />
                    <SortingTableHeader
                      sortingData={{}}
                      title={Strings.color}
                      sortingKey=""
                      width="25%"
                      sortingDisabled
                    />
                    <SortingTableHeader
                      sortingData={{}}
                      title={Strings.status}
                      sortingKey=""
                      width="20%"
                      sortingDisabled
                    />
                    <SortingTableHeader
                      sortingData={{}}
                      title=""
                      sortingKey=""
                      type="action"
                      width="10%"
                      sortingDisabled
                    />
                  </TableRow>
                </TableHead>
                {filteredRows.length > 0 && (
                  <TableBody>
                    {filteredRows.map((row: any, index: number) => (
                      <TableRow key={index}>
                        <SortingTableCell
                          width="25vw"
                          type="left"
                          content={row.name}
                        />
                        <SortingTableCell
                          width="20vw"
                          content={row.hours}
                        />
                        <SortingTableCell
                          width="20vw"
                          content={
                            <Box style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <Box
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  backgroundColor: row.color,
                                  border: "1px solid #ccc",
                                  borderRadius: "4px"
                                }}
                              />
                              <Typography>{row.color}</Typography>
                            </Box>
                          }
                        />
                        <SortingTableCell
                          width="15vw"
                          type="right"
                          style={{
                            marginTop: 0,
                            marginBottom: 0,
                            paddingTop: 8,
                            paddingBottom: 7,
                          }}
                          content={
                            <CustomSwitch
                              checked={row.status === "Active"}
                              onChange={(checked) => {
                                this.handleStatusChange(row.id, checked);
                              }}
                            />
                          }
                        />
                        <SortingTableCell
                          width="15vw"
                          type="action"
                          content={
                            <IconButton
                              id={"IconButton" + index}
                              onClick={(event) => {
                                const position = event.currentTarget.getBoundingClientRect();
                                this.setState({
                                  popOverOpened: true,
                                  popOverItemId: row.id,
                                  popOverItemStatus: row.status,
                                  popOverLeft: position.left + window.scrollX,
                                  popOverTop: position.top + window.scrollY,
                                });
                              }}
                            >
                              <MoreVertIcon />
                            </IconButton>
                          }
                        />
                      </TableRow>
                    ))}
                  </TableBody>
                )}
                {this.state.loading && (
                  <>
                    {Array(5)
                      .fill(1)
                      .map((_, index) => (
                        <TableBody key={index}>
                          <TableRow>
                            {[...Array(5)].map((_, cellIndex) => (
                              <TableRowsSkeleton key={cellIndex} />
                            ))}
                          </TableRow>
                        </TableBody>
                      ))}
                  </>
                )}
              </Table>
              {filteredRows.length === 0 && !this.state.loading && (
                <div style={{ ...webStyle.noRecordsFound, textAlign: "center" }}>
                  {Strings.noDataFound}
                </div>
              )}
              <TablePopover
                data-test-id="popover"
                permissionStatus={{
                  mainPermission: true,
                  viewPermission: true,
                  editPermission: true,
                  deletePermission: false,
                  createPermission: true,
                  deactivatePermission: false,
                }}
                open={this.state.popOverOpened}
                onClose={() => this.setState({ popOverOpened: false })}
                top={this.state.popOverTop}
                left={this.state.popOverLeft}
                onView={() => this.handleViewConfig(this.state.popOverItemId)}
                onEdit={() => this.handleEditConfig(this.state.popOverItemId)}
                deactivateTitle="Late Delivery Config"
                isActive={this.state.popOverItemStatus === "Active"}
              />
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10]}
              component="div"
              rowsPerPage={this.state.pageSize}
              onPageChange={this.handlePageChange}
              count={rows.length}
              page={this.state.page}
            />
          </Box>
        </Box>
      </ThemeProvider>
    );
    // Customizable Area End
  }
}

// Customizable Area Start
const webStyle = {
  table: {
    minWidth: 700,
  },
  mainWrapper: {
    fontFamily: "Montserrat",
  },
  pageHeader: {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "24px",
    lineHeight: "29px",
  },
  headerWrapper: {
    justifyContent: "space-between",
    display: "flex",
    marginBottom: 32,
    alignItems: "center",
  },
  addButton: {
    background: "#204B9C",
    fontWeight: 600,
    fontSize: "16px",
    color: "#FFFFFF",
    lineHeight: "24px",
    height: "56px",
    width: "240px",
    borderRadius: "8px",
  },
  filterButton: {
    cursor: "pointer",
    padding: "16px",
    border: "solid 1px rgba(32, 75, 156, 1)",
    borderRadius: "15px",
  },
  contentWrapper: {
    marginTop: 56,
    marginRight: 32,
  },
  noRecordsFound: {
    fontSize: 16,
    fontWeight: 600,
    width: "100%",
    padding: "24px",
  },
};
// Customizable Area End
